export const repairAnalysisInfo = {
  headline: "Die Fehler in diesem Objekt wurden durch unsere Reperatursoftware automatisch behoben.",
  numberOfFlippedPolygons: "Normalen gedreht:",
  numberOfRemovedFlatOpenShells: "Unverbundene Flächen entfernt:",
  numberOfClosedOpenLoops: "Löcher geschlossen:",
  numberOfMergedVertexPairs: "Vereinigte Vertexpaare:",
  repairPictureHeadline: "Durchgeführte Reparaturen:",
  repairPictureControls: "Bitte drehen Sie das Modell um alle Seiten auf durchgeführte Reparaturen zu überprüfen (Größere Änderungen sind rot markiert).",
  fileIsReadyForPrinting: "Die Datei kann jetzt im 3D-Druck verarbeitet werden. Sie können die Änderungen hier nachvollziehen oder die Datei zur Ansicht herunterladen.",
  downloadFile: "Herunterladen",
  continue: "Schließen",
}